import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const NutritionalInfoFields = ({ formData, onChange, schema }) => {
  const [ingredients, setIngredients] = useState(null);

  useEffect(() => {
    const ingredientKeys = ingredients ? Object.keys(ingredients) : [];
    if (formData && (ingredientKeys.length === 0 || ingredientKeys.every((key) => ingredients[key] === ''))) {
      setIngredients(formData);
    }
  }, [formData]);

  const onFieldChange = (e, fieldName) => {
    const newIngredients = ingredients || {};
    newIngredients[fieldName] = e.target.value;
    setIngredients(newIngredients);
    onChange(newIngredients);
  };

  return (
    <div className="form-block">
      <div className="m-b-2">
        <strong>
          <FormattedMessage id="item.form.field.nutritional.info.legend" />
        </strong>
      </div>
      <div className="row">
        <div className="col-6 col-sm-4 col-md-3">
          <div className="form-group field field-string">
            <label className="control-label">
              <FormattedMessage id="item.form.field.nutritional.info.energy.label" />
            </label>
            <input
              className="form-control"
              placeholder=""
              type="text"
              value={ingredients?.energyInKcal}
              onChange={(e) => onFieldChange(e, 'energyInKcal')}
            />
          </div>
        </div>
        <div className="col-6 col-sm-4 col-md-3">
          <div className="form-group field field-string">
            <label className="control-label">
              <FormattedMessage id="item.form.field.nutritional.info.fat.label" />
            </label>
            <input
              className="form-control"
              placeholder=""
              type="text"
              value={ingredients?.fat}
              onChange={(e) => onFieldChange(e, 'fat')}
            />
          </div>
        </div>
        <div className="col-6 col-sm-4 col-md-3">
          <div className="form-group field field-string">
            <label className="control-label">
              <FormattedMessage id="item.form.field.nutritional.info.fatty.acids.label" />
            </label>
            <input
              className="form-control"
              placeholder=""
              type="text"
              value={ingredients?.fattyAcids}
              onChange={(e) => onFieldChange(e, 'fattyAcids')}
            />
          </div>
        </div>
        <div className="col-6 col-sm-4 col-md-3">
          <div className="form-group field field-string">
            <label className="control-label">
              <FormattedMessage id="item.form.field.nutritional.info.carbs.label" />
            </label>
            <input
              className="form-control"
              placeholder=""
              type="text"
              value={ingredients?.carbs}
              onChange={(e) => onFieldChange(e, 'carbs')}
            />
          </div>
        </div>
        <div className="col-6 col-sm-4 col-md-3">
          <div className="form-group field field-string">
            <label className="control-label">
              <FormattedMessage id="item.form.field.nutritional.info.sugar.label" />
            </label>
            <input
              className="form-control"
              placeholder=""
              type="text"
              value={ingredients?.sugar}
              onChange={(e) => onFieldChange(e, 'sugar')}
            />
          </div>
        </div>
        <div className="col-6 col-sm-4 col-md-3">
          <div className="form-group field field-string">
            <label className="control-label">
              <FormattedMessage id="item.form.field.nutritional.info.protein.label" />
            </label>
            <input
              className="form-control"
              placeholder=""
              type="text"
              value={ingredients?.protein}
              onChange={(e) => onFieldChange(e, 'protein')}
            />
          </div>
        </div>
        <div className="col-6 col-sm-4 col-md-3">
          <div className="form-group field field-string">
            <label className="control-label">
              <FormattedMessage id="item.form.field.nutritional.info.salt.label" />
            </label>
            <input
              className="form-control"
              placeholder=""
              type="text"
              value={ingredients?.salt}
              onChange={(e) => onFieldChange(e, 'salt')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NutritionalInfoFields;
